
// ==================== CSV/Excel Parsing Helpers ====================

export function normalizeHeader(h) {
  return (h ?? "")
    .toString()
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();
}

export function parseCSVText(text) {
  const csvRegex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
  const rows = (text || "")
    .split(/\r?\n/)
    .map((r) => r.trim())
    .filter(Boolean);
  if (!rows.length) return { headers: [], dataRows: [] };

  const headers = rows[0].split(csvRegex).map((h) => h.replace(/^"|"$/g, "").trim());
  const dataRows = rows.slice(1).map((row) =>
    row.split(csvRegex).map((v) => (v ? v.replace(/^"|"$/g, "").trim() : ""))
  );

  return { headers, dataRows };
}

// ==================== Service Record Helpers ====================

export function toNumber(value) {
  return Number(value.replace(/,/g, ""));
}

export function formatPeso(value) {
  return `₱ ${value.toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function getAbbreviation(selectedType) {
  if (!selectedType) return "";
  let abbreviation = "";
  let isNewWord = true;
  for (let i = 0; i < selectedType.length; i++) {
    const char = selectedType[i];
    if (char === " ") {
      isNewWord = true;
    } else if (isNewWord) {
      abbreviation += char;
      isNewWord = false;
    }
  }
  return abbreviation;
}

// ==================== Utility Helpers ====================

export async function processWithConcurrencyLimit(tasks, concurrency = 5) {
  const results = [];
  for (let i = 0; i < tasks.length; i += concurrency) {
    const batch = tasks.slice(i, i + concurrency);
    const batchResults = await Promise.all(batch);
    results.push(...batchResults);
  }
  return results;
}
